import useUsuario from "./useUsuario";

function useCheckBlockModuloCadencia(checkBlockModuloCadencia) {
  const { featureToggles } = useUsuario();
  if (checkBlockModuloCadencia) {
    return featureToggles.cadenciaModuloOculto;
  }

  return false;
}

export default useCheckBlockModuloCadencia;
